import { Injectable } from '@angular/core';
import { ArticleEnums } from 'src/app/enum/article-enums';
import { InventoryEnums } from 'src/app/enum/inventory-enums';

@Injectable({
  providedIn: 'root'
})
export class TypeInventoryService {

  constructor() { }

  getTypeInventory(articleTypeId: number): number {
    const map: Record<number, number> = {
      [ArticleEnums.tipoEquipo]: InventoryEnums.equipos,
      [ArticleEnums.tipoInsumo]: InventoryEnums.insumos,
      [ArticleEnums.tipoReparación]: InventoryEnums.ninguno,
      [ArticleEnums.tipoAccesorio]: InventoryEnums.equipos,
      [ArticleEnums.tipoServicio]: InventoryEnums.ninguno,
      [ArticleEnums.tipoOtro]: InventoryEnums.otro,
    };
    return map[articleTypeId] ?? InventoryEnums.otro;
  }

}
